

































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import ViewMixins from './mixins';

@Component
export default class HelpStatusPage extends mixins(Vue, ViewMixins) {
}
